import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {
  ColumnFilter,
  DataTableColumnData,
  DatatableComponent,
  DataTableConfig,
  DataTableDataSource,
  DataTableLazyLoadDataSource,
  DataTableLazyLoadRefresher, DataTableObservableCompletionListener, DataTableObservableErrorListener,
  TableAction
} from '@cas-hub/acabim-common-client';
import {AssetTypeService} from '../../../_services/asset-type-service';
import {AssetTypeResponse} from '../../../_models/asset-type.model';

@Component({
  selector: 'acabim-admin-asset-type',
  templateUrl: './asset-type.component.html',
  styleUrls: ['./asset-type.component.scss']
})
export class AssetTypeComponent implements OnInit, OnDestroy {

  assetTypesSub: Subscription | null = null;
  addAssetTypeModal = false;
  editAssetTypeModal = false;
  @ViewChild('dataTable') public dataTable!: DatatableComponent;
  public dataSources: DataTableDataSource<any>[] = [];

  constructor(
      private assetTypeService: AssetTypeService
  ) {}

  ngOnInit(): void {
    this.dataSources.push(
        new AssetTypeDataSource(
            (first, length, sortOrder, sortField, filters) =>
                this.assetTypeService.getAssetTypes(),
            (tableName: string, error: Error) => {
              console.log('[AssetTypeComponent] Error in retrieving data in table ' + tableName);
            },
            (tableName: string) => {
              console.log('[AssetTypeComponent] Completed retrieving data in table ' + tableName);
            }, (action: TableAction) => {
              if (action.id === 0) {
                console.log('[AssetTypeComponent] At action 0');
              } else if (action.id === 1) {
                console.log('[AssetTypeComponent] At action 1');
              }
            }
        )
    );

  }

  ngOnDestroy(): void {
    if (this.assetTypesSub != null) {
      this.assetTypesSub.unsubscribe();
    }
  }

  // Add
  onAddAssetType(): void {
    this.addAssetTypeModal = true;
  }

  setAddAssetTypeModal(value: boolean): void {
    this.addAssetTypeModal = value;
  }

  onAddCompletion(completed: string) {
    console.log(completed);
    this.addAssetTypeModal = false;
    if (completed === 'added') {
      this.setAddAssetTypeModal(false);
      this.dataTable?.requestImmediateDataRefresh();
    } else if (completed === 'cancelled') {
      this.setAddAssetTypeModal(false);
    }
  }

  // Edit
  setEditAssetTypeModal(value: boolean): void {
    this.editAssetTypeModal = value;
    this.dataSources[0].showDetails = value;
  }

  onEditCompletion(completed: string) {
    console.log(completed);
    this.editAssetTypeModal = false;
    if (completed === 'updated' || completed === 'deleted') {
      this.setEditAssetTypeModal(false);
      this.dataTable?.requestImmediateDataRefresh();
    } else if (completed === 'cancelled') {
      this.setEditAssetTypeModal(false);
    }
  }
}

export class AssetTypeDataSource extends DataTableLazyLoadDataSource<AssetTypeResponse> {

  readonly columnData: DataTableColumnData[] =
      [
        {displayName: 'Name', objectPropertyName: 'name', colWidth: '15rem'},
        {displayName: 'Description', objectPropertyName: 'description'}
      ];

  readonly config: DataTableConfig = {
    tableHeading: '',
    isSearchEnabled: false,
    searchPlaceHolder: 'Search asset types',
    emptyMessage: '',
    globalFilterFields: [],
    hasCheckbox: false,
    hasDetailsButton: true,
    isLazyLoadingEnabled: false,
    isPaginationEnabled: false,
    hasFilters: false,
    isExportEnabled: false,
    hasActions: false
  };

  readonly columnFilters: ColumnFilter[] = [];

  readonly actions: TableAction[] = [{name: 'Archive', id: 0}, {name: 'Group', id: 1}];

  onDataExpanded(value: AssetTypeResponse): void {
  }

  constructor(readonly refresher: DataTableLazyLoadRefresher<AssetTypeResponse>,
              readonly observableErrorListener?: DataTableObservableErrorListener,
              readonly observableCompleteListener?: DataTableObservableCompletionListener,
              readonly actionListener?: (action: TableAction) => void) {
    super(refresher, observableErrorListener, observableCompleteListener);
  }

  onAction(action: TableAction): void {
    if (this.actionListener) {
      this.actionListener(action);
    }
  }
}
